import * as Blockly from "blockly";
import BlocklyJs from "blockly/javascript";
import {
  BlocklyJsOperator,
  initPropertyGetterBlock,
  initPropertySetterBlock,
  initPropertySetterByTimeBlock,
} from "common/blockly";
import { SHADOW_SIZE_MAX, SHADOW_SIZE_MIN } from "common/components";

export const InitShadowPropertyBlock = (
  components: string[][],
  defaultComponent?: string | undefined
) => {
  function showEditor(e) {
    e.stopPropagation();
    e.preventDefault();
    Blockly.dialog.component(
      { x: e.x, y: e.y },
      this.getValue(),
      components.length === 0 ? [["パーツ", ""]] : components,
      function (value: string) {
        if (value !== null) {
          this.setValue(value);
        }
      }.bind(this)
    );
  }

  Blockly.Blocks["component_property_getter_shadow_color"] = {
    init: function () {
      this.jsonInit(
        initPropertyGetterBlock(
          "component_property_getter_shadow_color",
          "%{BKY_GETTER_SHADOW_COLOR}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "colour_blocks",
          "Colour"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
    },
  };
  BlocklyJs["component_property_getter_shadow_color"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const code =
      component[0] === ""
        ? ""
        : `codeGen.get${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowColor("${component[1]}")`;
    return [code, BlocklyJsOperator.ORDER_NONE];
  };

  Blockly.Blocks["component_property_setter_shadow_color"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterBlock(
          "component_property_setter_shadow_color",
          "%{BKY_SETTER_SHADOW_COLOR}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "colour_blocks",
          "Colour"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
    },
  };
  BlocklyJs["component_property_setter_shadow_color"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const value = BlocklyJs.valueToCode(
      block,
      "value",
      BlocklyJsOperator.ORDER_NONE
    );
    const code =
      component[0] === ""
        ? ""
        : `codeGen.set${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowColor("${component[1]}", ${value});\n`;
    return code;
  };

  Blockly.Blocks["component_property_getter_shadow_radius"] = {
    init: function () {
      this.jsonInit(
        initPropertyGetterBlock(
          "component_property_getter_shadow_radius",
          "%{BKY_GETTER_SHADOW_RADIUS}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
    },
  };
  BlocklyJs["component_property_getter_shadow_radius"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const code =
      component[0] === ""
        ? ""
        : `codeGen.get${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowRadius("${component[1]}")`;
    return [code, BlocklyJsOperator.ORDER_ATOMIC];
  };

  Blockly.Blocks["component_property_setter_shadow_radius"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterBlock(
          "component_property_setter_shadow_radius",
          "%{BKY_SETTER_SHADOW_RADIUS}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > SHADOW_SIZE_MAX) {
              return SHADOW_SIZE_MAX;
            } else if (value < SHADOW_SIZE_MIN) {
              return SHADOW_SIZE_MIN;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_shadow_radius"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const value = BlocklyJs.valueToCode(
      block,
      "value",
      BlocklyJsOperator.ORDER_NONE
    );
    const code =
      component[0] === ""
        ? ""
        : `codeGen.set${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowRadius("${component[1]}", ${value});\n`;
    return code;
  };

  Blockly.Blocks["component_property_setter_shadow_radius_by_step"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterBlock(
          "component_property_setter_shadow_radius_by_step",
          "%{BKY_SETTER_SHADOW_RADIUS_BY_STEP}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "logic_blocks",
          "Number"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > SHADOW_SIZE_MAX) {
              return SHADOW_SIZE_MAX;
            } else if (value < -SHADOW_SIZE_MAX) {
              return -SHADOW_SIZE_MAX;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_shadow_radius_by_step"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const value = BlocklyJs.valueToCode(
      block,
      "value",
      BlocklyJsOperator.ORDER_NONE
    );
    const code =
      component[0] === ""
        ? ""
        : `codeGen.set${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowRadiusByStep("${component[1]}", ${value});\n`;
    return code;
  };

  Blockly.Blocks["component_property_setter_shadow_radius_by_time"] = {
    init: function () {
      this.jsonInit(
        initPropertySetterByTimeBlock(
          "component_property_setter_shadow_radius_by_time",
          "%{BKY_SETTER_SHADOW_RADIUS_BY_TIME}",
          components.length === 0 ? [["パーツ", ""]] : components,
          "math_blocks",
          "Number"
        )
      );
      const filed = this.getField("component_id") as Blockly.FieldDropdown;
      filed.showEditor = showEditor;
      if (defaultComponent) {
        this.getField("component_id").setValue(defaultComponent);
      }
      this.setOnChange(() => {
        const inputTarget = this.getInputTargetBlock("value") as Blockly.Block;
        if (inputTarget && inputTarget.getField("NUM")) {
          inputTarget.getField("NUM").setValidator((value: number) => {
            if (value > SHADOW_SIZE_MAX) {
              return SHADOW_SIZE_MAX;
            } else if (value < SHADOW_SIZE_MIN) {
              return SHADOW_SIZE_MIN;
            } else {
              return value;
            }
          });
        }
      });
    },
  };
  BlocklyJs["component_property_setter_shadow_radius_by_time"] = function (
    block: Blockly.BlockSvg
  ) {
    const component = block.getField("component_id").getValue().split("_");
    const time = BlocklyJs.valueToCode(
      block,
      "time",
      BlocklyJsOperator.ORDER_NONE
    );
    const value = BlocklyJs.valueToCode(
      block,
      "value",
      BlocklyJsOperator.ORDER_NONE
    );
    const code =
      component[0] === ""
        ? ""
        : `await codeGen.set${
            component[0].charAt(0).toUpperCase() + component[0].slice(1)
          }ShadowRadiusByTime("${component[1]}", ${time}, ${value});\n`;
    return code;
  };
};
